export class Fields {
  constructor(CompanyId, ColumnName, ColumnDataType, ColumnLength, IsRequired, DefaultValue) {
    this.CompanyId = CompanyId;
    this.ColumnName = ColumnName;
    this.ColumnDataType = ColumnDataType;
    this.ColumnLength = ColumnLength;
    this.IsRequired = IsRequired;
    this.DefaultValue = DefaultValue;
  }
}